import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';


@Injectable({
    providedIn: 'root'
})
export class TitleService {

    constructor(
        private title: Title,
        private translate: TranslateService
    ) {
    }

    updateTitleText(translate: TranslateService, text: string) {
        this.translate.get('TITLE.MAIN',).subscribe((translated: string) => {
            if (text == null || text.length === 0) {
                this.title.setTitle(translated);
                return;
            }

            this.title.setTitle(text + ' · ' + translated);
        });
    }

}
